import { authedFetch } from './authedFetch';

/**
 * Call one of this app's serverless routes and get its JSON, throwing a
 * readable Error when it fails.
 *
 * The canvas came from Shadowland Title, whose apiFetch parsed the body
 * and threw on a non-2xx. Paraclete's authedFetch deliberately does
 * neither — it returns the Response so callers can redirect on a 401 —
 * so this is the adapter between the two contracts rather than a second
 * fetch wrapper. Without it the canvas's error handling, which reads
 * err.message, would silently treat a 500 as a successful empty result.
 */
export async function canvasApiFetch(path, { method = 'GET', body, signal } = {}) {
  const res = await authedFetch(path, {
    method,
    signal,
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });

  const text = await res.text();
  let payload = null;
  try {
    payload = text ? JSON.parse(text) : null;
  } catch {
    payload = { error: text };
  }

  if (!res.ok) {
    throw new Error(payload?.error || `Request failed (${res.status})`);
  }
  return payload;
}
